import { initialState } from "./state"

export default {
  setDocument: (state, document) => (state.document = document),
  setType: (state, type) => (state.type = type),
  setRG: (state, payload) => (state.rg = payload),
  setName: (state, payload) => (state.name = payload),
  setBirthDate: (state, payload) => (state.birthDate = payload),
  setMotherName: (state, payload) => (state.motherName = payload),
  setFatherName: (state, payload) => (state.fatherName = payload),
  setGender: (state, payload) => (state.gender = payload),
  setSchooled: (state, payload) => (state.schooled = payload),
  setMaritalStatus: (state, payload) => (state.maritalStatus = payload),
  setProfession: (state, payload) => (state.profession = payload),

  setCompanyName: (state, payload) => (state.companyName = payload),
  setCompanyType: (state, payload) => (state.companyType = payload),
  setOpeningDate: (state, payload) => (state.openingDate = payload),
  setResponsibleName: (state, payload) => (state.responsible.name = payload),
  setResponsibleCpf: (state, payload) => (state.responsible.cpf = payload),
  setState: (state, payload) => (state.state = payload),
  setStateRegistration: (state, payload) => (state.stateRegistration = payload),
  setContactName: (state, payload) => (state.contactName = payload),

  setEmail: (state, payload) => (state.email = payload),
  setCellphone: (state, payload) => (state.cellphone = payload),
  setLandline: (state, payload) => (state.landline = payload),
  setAnotherContact: (state, payload) => (state.anotherContact = payload),
  setNote: (state, payload) => (state.note = payload),

  resetClient: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  }
}
